module.exports = __webpack_public_path__ + "img/percentage-icon.fcd7ec81.svg";